module.exports = __webpack_public_path__ + "img/42.3f8ded59.svg";